import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';

const ContentSecurityPolicy = () => {
  const contentSecurityPolicy = useSelector((state) =>
    // @ts-expect-error FIXME TS2345
    featureFlagsSelectors.getFeatureFlag(state, 'contentSecurityPolicy'),
  );
  return (
    <Helmet defaultTitle='Simplifi' titleTemplate='Simplifi - %s'>
      <meta name='description' content='Simplifi Web App' />
      <link rel='icon' href='favicon.ico' />
      <link rel='apple-touch-icon' href='apple-touch-icon.png' />
      <meta httpEquiv='Content-Security-Policy' content={contentSecurityPolicy} />
    </Helmet>
  );
};
export default ContentSecurityPolicy;
